import { WatchAccountService } from './../../../services/watch-account.service';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { IAccount, IProfile, IFunnel } from '../../../interfaces/graph-types';
import { AccountService } from '../../../services/account.service';
import { Subscription, Observable, Subject } from 'rxjs';
import { GlobalWindow } from '../../../main.window';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ModalCreateCandidateComponent } from '../../modals/create-candidate/modal-create-candidate.component';
import { SubscriptionNotificationService } from '../../../services/subscription-notification.service';

declare let window: GlobalWindow;

@Component({
  selector: '[account-navbar]',
  template: require('./account-navbar.component.pug'),
  styles: [require('./account-navbar.component.css').toString()],
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountNavbarComponent implements OnInit {
  bsModalRef: BsModalRef;
  subReason: Subscription = null;
  candidateSubjectId: Subject<string>;

  currentAccount: IAccount = null;
  accsub: Subscription = null;
  accsub2: Subscription = null;
  currentFunnel: IFunnel = null;

  planSub: Subscription = null;
  plan = 'trial';

  openNotifications = new Subject<boolean>();

  profile$: Observable<IProfile>;

  // -------------------------------------------------------------------
  constructor(
    private modalService: BsModalService,
    private watch: WatchAccountService,
    private account_service: AccountService,
    private subscriptionNotificationService: SubscriptionNotificationService,
    private cdr: ChangeDetectorRef,
  ) {
    this.candidateSubjectId = new Subject<string>();
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.planSub = this.subscriptionNotificationService.planName.subscribe(
      plan => {
        this.plan = plan;
        //        this.cdr.detectChanges();
      },
    );

    this.accsub = this.watch.accountId().subscribe(account_id => {
      this.accsub2 = this.account_service
        .getAccountInfo(account_id)
        .subscribe(response => {
          this.currentAccount = response;
          //          this.cdr.detectChanges();

          if (response.plan) {
            this.subscriptionNotificationService.planName.next(response.plan);
          }
        });
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.accsub) {
      this.accsub.unsubscribe();
    }
    if (this.accsub2) {
      this.accsub2.unsubscribe();
    }
    if (this.planSub) {
      this.planSub.unsubscribe();
    }
    if (this.subReason) {
      this.subReason.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  toggleNotifications() {
    this.openNotifications.next(true);
  }

  // -------------------------------------------------------------------
  OpenCandidateModal() {
    //this.account_service.account().subscribe(response => {

    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      org_id: 0, //response.organization.id,
    };

    this.bsModalRef = this.modalService.show(
      ModalCreateCandidateComponent,
      options,
    );
    this.bsModalRef.content.closeBtnName = 'Close';
    this.subReason = this.bsModalRef.content.reason.subscribe(res => {
      this.selectCandidateInfo(res);
    });
  }

  // -------------------------------------------------------------------
  getAccountId() {
    return this.watch.accountId().getValue();
  }

  viewingCandidate: string;
  // -------------------------------------------------------------------
  selectCandidateInfo(candidateId) {
    this.viewingCandidate = candidateId;
    this.candidateSubjectId.next(candidateId);
  }

  // -------------------------------------------------------------------
  closeCandidateInfo() {
    this.viewingCandidate = null;
  }

  // -------------------------------------------------------------------
  brandClass() {
    let newClass = {};

    newClass['brand-' + window.env] = true;

    return newClass;
  }

  // -------------------------------------------------------------------
  arrowClass() {
    let newClass = {};

    newClass['arrow-' + window.env] = true;

    return newClass;
  }
}
